import dataLayer from '../../js/utils/dom/dataLayer';

/**
 * Wrapper to track BYG events with dataLayer object
 *
 * @param {String} experienceName The name of the experience
 * @param {String} modalType The type of the modal (e.g. byg, modal)
 * @returns {Object} dataLayer object push result
 */
function dataLayerDisplayByg(experienceName, modalType = 'byg') {
  return dataLayer(`display-${modalType}-${experienceName}`);
}

export default dataLayerDisplayByg;
